import { dispatch, PaymentStore } from "@nf/common";
import { usePaymentDetails } from "../../hooks/usePaymentDetails";
import { useTranslation } from "next-i18next";
import { useCallback } from "react";
import { SettingsSubscriptionButton } from "../../../SettingsSubscriptionButton/SettingsSubscriptionButton";

export const ChangePaymentDetailsButton = () => {
  const { t } = useTranslation("translations");
  const { isPaymentLoading } = usePaymentDetails();

  const changePaymentDetails = useCallback(() => {
    dispatch(PaymentStore.Actions.createPaymentDetails());
  }, []);

  return (
    <SettingsSubscriptionButton
      onClick={changePaymentDetails}
      loading={isPaymentLoading}
      disabled={isPaymentLoading}
      variant="plain"
    >
      {t("web_payment_details_edit_payment_details")}
    </SettingsSubscriptionButton>
  );
};
